// import React from 'react'
// import "./HCategoryCard.css"
// import bg from "../../Assets/Category/speciality-list-bg.png"
// import { PiHospitalFill } from "react-icons/pi";

// const HCategoryCard = ({ item }) => {
//     return (
//         <div className='HCategory-box-card' key={item.id}>
//             <div className="hcategory-card-bg">
//                 <img src={bg} alt="" />
//             </div>
//             <div className="hcategory-card-detail">
//                 <div className="hcategory-image">
//                     <img src={item.cover} alt="" />
//                 </div>
//                 <h5>{item.title}</h5>
//                 <p>{item.description}</p>
//                 <div className="hcategory-card-detail-items">
//                     {item.brands.map((i) => (
//                         <div className="hcategory-items-card">
//                             <img src={i.cover} alt="" />
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default HCategoryCard

import React from 'react'
import "./HCategoryCard.css"
import bg from "../../Assets/Category/speciality-list-bg.png"
import { PiHospitalFill } from "react-icons/pi";

const HCategoryCard = ({ item, navigate }) => {
    const handleLearnMore = () => {
        navigate(`/pukhya/${item.slug}`);
    };

    return (
        <div className='HCategory-box-card' key={item.id}>
            <div className="hcategory-card-bg">
                <img src={bg} alt="" />
            </div>
            <div className="hcategory-card-detail">
                <div className="hcategory-image">
                    <img src={item.cover} alt="" />
                </div>
                <h5>{item.title}</h5>
                <p>{item.description}</p>
                <div className="hcategory-card-detail-items">
                    {item.brands.map((i) => (
                        <div className="hcategory-items-card">
                            <img src={i.cover} alt="" />
                        </div>
                    ))}
                </div>

      
                <button
                    className="learn-more-btn"
                    onClick={handleLearnMore}
                    style={{
                        marginTop: "10px",
                        padding: "8px 16px",
                        backgroundColor: "#f0800f",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: "500",
                    }}
                >
                    Learn More
                </button>
            </div>
        </div>
    )
}

export default HCategoryCard

